<template>
<el-dialog title="绑定销售" :visible.sync="isShow" :append-to-body="true">
  <div class="allocate-box">
    <div class="department-tree">
      <el-tree :data="tree" :props="defaultProps" @node-click="getDepartmentUserList"></el-tree>
    </div>
    <div class="user-list-box">
      <el-form :model="query" :inline="true" label-width="80px">
        <el-form-item>
          <el-input v-model="query.keyword" clearable clear="searchUser" placeholder="用户名或者昵称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchUser">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="userTableData" ref="userTable" @selection-change="handleUserChange" style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="department" label="部门"></el-table-column>
        <el-table-column prop="realname" label="真实姓名"></el-table-column>
        <el-table-column label="商户名称">
          <template slot-scope="scope">
            <template v-for="(item, index) in scope.row.store">
              <el-tag :key="index" :type="index % 2 === 0 ? 'primary' : 'success'" disable-transitions>{{ item.title }}</el-tag>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" @click="addSaleman">确 定</el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  props: {
    parent: {}
  },
  data() {
    return {
      isShow: false,
      store_id: 0,
      userTableData: [],
      // 弹框搜索
      query: {
        hotel_id: '',
        keyword: ''
      },
      // tree 默认节点
      tree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      staffs: []
    };
  },
  methods: {
    show(storeId) {
      this.store_id = storeId;
      this.isShow = true;
      this.getTree();
    },
    // 获取Tree数据
    getTree() {
      let url = '/api/ucenter.department/getTree';
      let that = this;
      this.$post(url, {}).then(function (response) {
        that.tree = response.data.tree;
      });
    },
    // tree 获取部门下的所有员工
    getDepartmentUserList(e) {
      let that = this;
      let url = '/api/ucenter.user/getDepartmentUserList';
      let query = {
        id: e.id
      };
      // 添加或编辑客资信息
      that.$post(url, query).then(function (response) {
        if (response.code != '200') {
          that.$message.error(response.msg);
        } else {
          that.userTableData = response.data.list;
        }
      });
    },
    searchUser() {
      let that = this;
      let url = '/api/ucenter.user/getDepartmentUserList';
      // 添加或编辑客资信息
      that.$post(url, this.query).then(function (response) {
        if (response.code != '200') {
          that.$message.error(response.msg);
        } else {
          that.userTableData = response.data.list;
        }
      });
    },
    // 列表复选框选中状态
    handleUserChange(e) {
      let ids = [];
      e.forEach((row) => {
        ids.push(row.id);
      });
      this.staffs = ids;
    },
    // 新增销售
    addSaleman() {
      let _this = this;
      let url = '/api/dictionary.hotel/bindStaff';
      this.$post(url, {
        store_id: this.store_id,
        staff_id: this.staffs
      }).then(res => {
        _this.isShow = false;
        _this.parent.getBindedStaff(_this.store_id);
        this.$message({
          type: 'success',
          message: res.msg
        });
      });
    },

  }
}
</script>

<style lang="less" scoped>
.allocate-box {
  display: flex;
  height: 45vh;
  overflow: auto;

  .department-tree {
    flex: 0 30%;
    border-right: 1px solid #dedede;
    overflow: auto;
  }

  .user-list-box {
    flex: 1;
    padding: 0 20px;
    overflow-y: auto;
  }
}
</style>
